import React from 'react';
import styles from '../../styles/contacts/ContactsWorkspace.module.css';
import { AlertIcon, CardIcon, SearchIcon, UsersIcon } from './ContactsIcons';

const ICONS = {
  empty: UsersIcon,
  search: SearchIcon,
  error: AlertIcon,
  card: CardIcon,
};

/**
 * Shared shell for the four list-level states: first-run, no search results,
 * a filter that matches nothing, and a load failure.
 */
export default function ContactsEmptyState({ variant = 'empty', title, body, actions = [] }) {
  const Glyph = ICONS[variant] || UsersIcon;

  return (
    <div className={styles.state} role={variant === 'error' ? 'alert' : undefined}>
      <span className={styles.stateIcon} aria-hidden="true">
        <Glyph size={22} />
      </span>
      <p className={styles.stateTitle}>{title}</p>
      {body ? <p className={styles.stateBody}>{body}</p> : null}
      {actions.length > 0 ? (
        <div className={styles.stateActions}>
          {actions.map((action) => (
            <button
              key={action.label}
              type="button"
              className={`${styles.btn} ${action.primary ? styles.btnPrimary : styles.btnGhost}`}
              onClick={action.onClick}
            >
              {action.icon ? <action.icon size={16} /> : null}
              {action.label}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
